import {Skeleton} from '@material-ui/lab';
import React from 'react';

export const SkeletonCell: React.FC<{height?: number}> = ({height = 26}) => (
  <div className="truncate p-3">
    <Skeleton variant="text" height={height} />
  </div>
);
